import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["rasterData"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getDefaultDomain } from '@antv/l7-utils';
import RasterLayer from "../../raster";
import Tile from "./Tile";
var DEFAULT_COLOR_TEXTURE_OPTION = {
  positions: [0, 1],
  colors: ['#000', '#fff']
};

var RasterTile = /*#__PURE__*/function (_Tile) {
  _inherits(RasterTile, _Tile);

  var _super = _createSuper(RasterTile);

  function RasterTile() {
    _classCallCheck(this, RasterTile);

    return _super.apply(this, arguments);
  }

  _createClass(RasterTile, [{
    key: "initTileLayer",
    value: function () {
      var _initTileLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var attributes, layerOptions, sourceOptions, _ref, rampColors, domain, layer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                attributes = this.parent.getLayerAttributeConfig();
                layerOptions = this.getLayerOptions();
                sourceOptions = this.getSourceOption();
                _ref = this.getLayerOptions(), rampColors = _ref.rampColors, domain = _ref.domain;
                this.colorTexture = this.parent.textureService.getColorTexture(rampColors, domain);
                layer = new RasterLayer(_objectSpread(_objectSpread({}, layerOptions), {}, {
                  colorTexture: this.colorTexture
                })).source(sourceOptions.data, sourceOptions.options); // 初始化数据映射
                // tslint:disable-next-line: no-unused-expression

                attributes && Object.keys(attributes).forEach(function (type) {
                  var _attributes$attr, _attributes$attr2;

                  var attr = type; // @ts-ignore

                  layer[attr]((_attributes$attr = attributes[attr]) === null || _attributes$attr === void 0 ? void 0 : _attributes$attr.field, (_attributes$attr2 = attributes[attr]) === null || _attributes$attr2 === void 0 ? void 0 : _attributes$attr2.values);
                });
                _context.next = 9;
                return this.addLayer(layer);

              case 9:
                this.isLoaded = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initTileLayer() {
        return _initTileLayer.apply(this, arguments);
      }

      return initTileLayer;
    }()
  }, {
    key: "getSourceOption",
    value: function getSourceOption() {
      var rawSource = this.parent.getSource();

      var _this$sourceTile$data = this.sourceTile.data.data,
          rasterData = _this$sourceTile$data.rasterData,
          res = _objectWithoutProperties(_this$sourceTile$data, _excluded);

      return {
        data: rasterData,
        options: {
          parser: _objectSpread({
            type: 'raster',
            extent: this.sourceTile.bounds
          }, res),
          transforms: rawSource.transforms
        }
      };
    }
    /**
     * 用于 style 更新 colorTexture 的优化
     * @param arg
     */

  }, {
    key: "styleUpdate",
    value: function styleUpdate() {
      var _this = this;

      for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      var _ref2 = arg,
          _ref2$rampColors = _ref2.rampColors,
          rampColors = _ref2$rampColors === void 0 ? DEFAULT_COLOR_TEXTURE_OPTION : _ref2$rampColors,
          domain = _ref2.domain;
      this.colorTexture = this.parent.textureService.getColorTexture(rampColors, domain || getDefaultDomain(rampColors));
      this.layers.forEach(function (layer) {
        return layer.style({
          colorTexture: _this.colorTexture
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.layers.forEach(function (layer) {
        return layer.destroy();
      });
    }
  }]);

  return RasterTile;
}(Tile);

export { RasterTile as default };